export const FR = {
  preparing_zip: "Préparation du zip…",
  compressing: "Compression…",
  info_icon: "Une fois marqué comme terminé, aucun membre supplémentaire ne peut rejoindre ou être ajouté, et tous les groupes de discussion seront désactivés. Veuillez noter que le projet, ainsi que tous les groupes de discussion et données, resteront accessibles dans un état désactivé.",
  mark_is_done: "Êtes-vous sûr de vouloir marquer le projet comme terminé ? Une fois marqué, aucun membre supplémentaire ne peut rejoindre ou être ajouté, et tous les groupes de discussion seront désactivés. Veuillez noter que le projet, ainsi que tous les groupes de discussion et données, resteront accessibles dans un état désactivé.",
  mark_not_done: "Êtes-vous sûr de vouloir rouvrir le projet ? Une fois marqué comme ouvert, des membres supplémentaires peuvent rejoindre ou être ajoutés, et tous les groupes de discussion seront réactivés.",
  mark_as_completed: "Marquer le projet comme terminé",
  room_completed: "Projet terminé",
  room_members: "Membres du projet",
  deactivated_rooms: "Projets désactivés",
  deactivated_chats: "Discussions désactivées",
  completed_rooms: "Projets terminés",
  request_to_join_a_room: "Demande de rejoindre le projet",
  wants_to_rejoin_room: "Username souhaite rejoindre à nouveau le projet Roomname.",
  invited_you_to_join_room: "Username vous a invité à rejoindre le projet Roomname.",
  restart: "Redémarrer",
  update_text: "Une nouvelle mise à jour est disponible. Cliquez sur redémarrer pour installer la mise à jour.",
  update_availble: "Mise à jour disponible",
  Loading: "Chargement...",
  logout: "Déconnexion",
  back: "Retour",
  company_list: "Liste des entreprises",
  followers: "Abonnés",
  followings: "Abonnements",
  article: "Article",
  companies: "Entreprises",
  one_to_one_chat: "Discussion individuelle",
  profile: "Profil",
  company: "Entreprise",
  company_selection: "Sélection d'entreprise",
  home: "Accueil",
  contact: "Contact",
  add_company: "Ajouter une entreprise",
  add_project: "Ajouter un projet",
  capacities: "Capacités",
  work_area: "Zone de travail",
  company_services: "Services de l'entreprise",
  website: "Site web",
  search_contacts: "Rechercher des contacts",
  add_or_join_a_company: "Ajouter ou rejoindre une entreprise",
  follow: "Suivre",
  following: "Abonné",
  like: "J'aime",
  company_contacts: "Contact de l'entreprise",
  leave_the_company: "Quitter l'entreprise",
  news: "Actualités",
  earlier: "Plus tôt",
  action: "Action",
  another_action: "Autre action",
  something_else: "Autre chose",
  search: "Rechercher",
  search_rooms: "Rechercher des projets",
  search_articles: "Rechercher des articles",
  contacts: "Contacts",
  suggestions: "Suggestions",
  project_list: "Liste des projets",
  search_results: "Résultats de recherche",
  add_or_join_project: "Ajouter ou rejoindre un projet",
  details: "Détails",
  your_position_within_company: "Veuillez choisir votre position au sein de l'entreprise.",
  close_modal: "Fermer",
  map: "Carte",
  or: "Ou",
  name: "Nom*",
  street: "Rue*",
  house_number: "N°",
  postal_code: "Code postal",
  city: "Ville*",
  opened_by: "Ouvert par :",
  project_No: "N° de projet : ",
  building_type: "Type de bâtiment*",
  building_types: "Type de bâtiment",
  add_join: "Ajouter/Rejoindre",
  mandatory_fiels: "*champs obligatoires",
  invalid_fiels: "Ce champ est obligatoire",
  add_or_join_company: "Ajouter ou rejoindre une entreprise",
  name_of_the_company: "Nom de l'entreprise",
  edit_company_details: "Modifier les détails de l'entreprise",
  branch_of_the_building_industry: "Branche de l'industrie du bâtiment",
  corporate_form: "Forme juridique",
  position_within_company: "Position au sein de l'entreprise",
  request_confirmation: "Demandes de projet en attente",
  company_e_mail: "E-mail de l'entreprise",
  type_of_filter: "Tapez pour filtrer...",
  setting: "Paramètre",
  dashboard: "Tableau de bord",
  settings: "Paramètres",
  views: "Vues",
  times_seen: "fois vu",
  see_more: "...plus",
  see_less: "...moins",
  in_search: "en recherche",
  reset_password: "Réinitialiser le mot de passe",
  submit: "Soumettre",
  password: "Mot de passe",
  email: "E-mail",
  confirm_password: "Confirmer le mot de passe",
  reset_email: "Réinitialiser l'e-mail",
  update: "Mettre à jour",
  new_email: "Nouvel e-mail",
  kjuup_message: "Message Kjuup",
  delete_profile: "Supprimer le profil ?",
  my_position: "Ma position :",
  add: "ajouter",
  owner_company_admin: "Admin entreprise :",
  owner_company_admin_new: "Admin entreprise",
  mutual_contact: "contact mutuel",
  mutual_contacts: "contacts mutuels",
  co_owner: "Copropriétaire",
  managing_director: "Directeur général",
  associate: "Associé",
  secretary: "Secrétaire",
  employee: "Employé",
  project_manage: "Chef de projet",
  auto_chat_translation: "Traduction automatique du chat",
  translate_room_group_names: "Traduire les noms des groupes de discussion",
  translate_room_group_names_info: "Lorsque cette option est activée, les noms des groupes de discussion sont automatiquement traduits dans votre langue d'interface.",
  default_view_email: "Vue par défaut : E-Mail",
  default_view_email_info: "Lorsque cette option est activée, l'onglet E-Mail s'ouvre par défaut au lieu de Messages à l'ouverture de l'application.",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "Langue",
  english: "Anglais",
  german: "Allemand",
  french: "Français",
  italian: "Italien",
  change_language: "Changer de langue",
  my_companies: "Mes entreprises",
  employees: "Employés",
  invite_with_a: "Inviter sur Kjuup",
  add_member: "Ajouter un membre",
  add_user: "Ajouter un utilisateur",
  send_location: "Envoyer la position",
  assign_admin_rights: "Ajuster les droits d'admin",
  deactivate_company: "Désactiver l'entreprise",
  remove_employees: "Supprimer des employés",
  remove_members: "Supprimer des membres",
  no_user_found: "Aucun utilisateur trouvé !",
  approve: "Approuver !",
  deselect_all: "Tout désélectionner",
  select_all: "Tout sélectionner",
  translation_on_building_projects: "Traduction dans les projets",
  reported_capacities: "Services signalés",
  up_to_50m_exact: "Jusqu'à 50m exact",
  company_details_service: "Services de l'entreprise",
  company_contact: "Contact de l'entreprise",
  invite_with_link: "Inviter sur Kjuup",
  share_link: "Partager le lien",
  share_company_link: "Partager le lien",
  qr_code: "Code QR",
  copy_link: "Copier le lien",
  cancel_link: "Annuler le lien",
  who_has_confirmed_services: "Qui a confirmé vos services ?",
  projectss: "Projets",
  add_services: "Ajouter des services",
  services: "Services",
  save_text: "Enregistrer",
  share_on: "Partager sur :",
  articlen: "Article",
  invite_user_to_confirm_service: "Inviter des utilisateurs à confirmer les services de l'entreprise.",
  link_copied: "Lien copié !",
  email_copied: "E-mail copié !",
  personal_article: "Article personnel",
  company_article: "Article d'entreprise",
  characters_remaining: "Caractères restants",
  optional_information: "Informations optionnelles",
  project: "Projet",
  projects: "Projets...",
  abort: "Abandonner",
  preview: "Aperçu",
  post: "Publier",
  of: "de",
  remove: "Supprimer",
  free_capacity: "Portail d'emploi",
  current_status_overview: "Aperçu de l'état actuel",
  report_capacities: "Signaler des services",
  report_text: "Signaler",
  search_capacities: "Trouver des entrepreneurs",
  add_project_user: "Ajouter un utilisateur au projet",
  media: "Médias",
  links: "Liens",
  docs: "Docs",
  featured_products: "Produits en vedette...",
  title: "Titre",
  text: "Texte",
  feed_details: "Détails du fil",
  add_employee: "Ajouter un employé",
  latest: "Récent",
  my_projects: "Mes projets",
  cancel: "Annuler",
  continue: "Continuer",
  role_in_the_building_industry: "Rôle dans l'industrie du bâtiment",
  als: "en tant que",
  join: "rejoindre",
  find: "Trouver",
  request_to_join_a_company: "Demande de rejoindre l'entreprise",
  wants_to_join_the_company: "veut rejoindre l'entreprise",
  filter_by: "Filtrer par",
  ok: "Ok",
  close: "Fermer",
  weekly_statistics: "Statistiques hebdomadaires",
  is_following_you: "vous suit.",
  as: "en tant que",
  has_joined_the: "a rejoint l'entreprise",
  has_looked_at_your_profile: "a consulté votre profil.",
  time: "Heure",
  in_searches_in_past_week: "dans les recherches la semaine passée.",
  has_liked_your_article: "a aimé votre article.",
  has_published_a_new_article: "a publié un nouvel article.",
  you: "Vous",
  all_views: "Toutes les vues",
  all_profile_views: "Toutes les vues du profil",
  mutual_company: "entreprise mutuelle",
  artical_text: "Écrire un article...",
  you_have_appeared: "Vous êtes apparu",
  your_request_at_the_company: "Votre demande à l'entreprise",
  times_you_have_appeared_in_searches: "fois que vous êtes apparu dans les recherches",
  appear_more_often_in_searches: "Apparaître plus souvent dans les recherches",
  you_have_been_found: "Vous avez été trouvé",
  improve_profile: "Améliorer le profil",
  choose_existing_contact_for_single_chat: "Choisir un contact existant pour une discussion individuelle :",
  in_order_to_add_new_contacts: "Pour ajouter de nouveaux contacts, veuillez rechercher de nouveaux contacts sur la page de profil.",
  times_in_searches_in_the_last_week: "fois dans les recherches la semaine dernière. Mettez à jour votre profil et ajoutez plus de détails pour être trouvé plus facilement.",
  has_been_confirmed: "a été confirmé.",
  have_joined_the: "ont rejoint le",
  building_project: "projet de construction.",
  select_with_which_company_you_want_to_connect_to_the_project: "Sélectionnez l'entreprise que vous représenterez. Cela sera affiché aux autres participants.",
  select_with_which_company_you_want_to_connect_to_the_chat: "Sélectionnez l'entreprise que vous représenterez. Cela sera affiché aux autres participants.",
  select_internal_section: "Veuillez sélectionner la section interne",
  select_profile_image: "Sélectionner l'image de profil",
  share_user: "Partager l'utilisateur",
  contact_sender_message: "Partagez ce lien pour inviter un non-membre de Kjuup à Kjuup. Ce lien peut être utilisé par plusieurs personnes pour s'inscrire.",
  project_sender_message: "Partagez ce lien pour inviter un non-membre de Kjuup au projet. Ce lien peut être utilisé par plusieurs personnes pour s'inscrire et rejoindre le projet dans Kjuup.",
  company_sender_message: "Partagez ce lien pour inviter un non-membre de Kjuup à l'entreprise. Ce lien peut être utilisé par plusieurs personnes pour s'inscrire et rejoindre l'entreprise dans Kjuup.",
  contact_receivers_message: "Lien d'invitation pour rejoindre Kjuup. Veuillez cliquer sur le lien pour vous inscrire à Kjuup.",
  iphone: "iPhone :",
  iphone_recivers_message: "Si vous installez Kjuup via l'App Store d'Apple, vous devez cliquer sur ce lien après le téléchargement réussi pour pouvoir vous inscrire.",
  project_receivers_message: "Lien d'invitation pour rejoindre le projet dans Kjuup. Veuillez cliquer sur le lien pour vous inscrire à Kjuup et rejoindre le projet.",
  company_receivers_message: "Lien d'invitation à l'entreprise dans Kjuup. Veuillez cliquer sur le lien pour vous inscrire à Kjuup et rejoindre l'entreprise.",
  sign_in: "Se connecter",
  enter_your_email_add: "Entrez votre adresse e-mail",
  forgot_password: "Mot de passe oublié",
  dont_have_account: "Vous n'avez pas de compte ?",
  register: "S'inscrire",
  get_app: "Obtenir l'application",
  registration: "Inscription",
  dep_ing: "Dipl.-Ing.",
  dr: "Dr.",
  dr_ing: "Dr.-Ing.",
  dep_ing_arc: "Dipl.-Ing. Architecte",
  prof: "Prof.",
  first_name: "Prénom",
  last_name: "Nom",
  have_an_account: "Vous avez un compte ?",
  when_register_you_agree: "En vous inscrivant, vous acceptez nos",
  term_of_use: "conditions d'utilisation",
  to: "à",
  in_our: "Dans nos",
  data_policy: "politiques de données",
  they_find_out: "vous découvrirez,",
  we_provide_store_data: "comment nous collectons, traitons et stockons les informations.",
  leaving_company_text: "Voulez-vous vraiment quitter l'entreprise ? En quittant l'entreprise, vous quittez également tous les projets et groupes de discussion associés. Vous pouvez rejoindre ces projets avec une autre entreprise à tout moment.",
  delete_profile_text: "Voulez-vous vraiment supprimer votre profil ? Lorsque vous supprimez votre profil, toutes les connexions aux entreprises, projets et discussions seront supprimées. Vous pouvez créer un nouveau profil à tout moment.",
  confirm: "Confirmer",
  reject: "Rejeter",
  requet_to_leave: "Demande de départ",
  choose: "Choisir",
  your_add_member: "Ajouter un membre",
  if_you: "si vous",
  can_not_find: "ne trouvez pas votre contact ici.",
  please_wait: "Veuillez patienter...",
  imprint_gtc: "Mentions légales/CGV",
  register_confirm_title: "Confirmez votre e-mail avant de vous connecter",
  register_confirm_popup: "Veuillez vérifier votre adresse e-mail Kjuup avant de vous connecter. La connexion n'est possible qu'après cette confirmation. Nous vous avons envoyé un lien de confirmation. Si vous ne le voyez pas, consultez également votre dossier spam.",
  resend_confirmation_email: "Renvoyer l'e-mail de confirmation",
  resend_confirmation_sent: "Si cette adresse e-mail est en attente de confirmation, nous avons envoyé un nouveau lien.",
  PENDING_GROUP_USER: "ne recevra des messages qu'après confirmation de l'invitation au projet. Un message supplémentaire apparaîtra une fois l'invitation au projet confirmée.",
  PENDING: "Confirmation de l'invitation au projet en attente",
  denied_group_chat: " a refusé l'invitation au projet et a quitté ce groupe.",
  joined_group_chat: " a rejoint ce groupe",
  you_joined_group_chat: "Vous avez rejoint ce groupe.",
  Others: "Autres",
  LEFT_GROUP: "a quitté ce groupe de discussion.",
  YOU_LEFT_GROUP: "avez quitté ce groupe de discussion.",
  days: "jours",
  day: "jour",
  hour: "heure",
  hide_project: "Masquer le projet",
  hide_project_popup_text: "Si vous masquez les projets, ils ne peuvent pas être trouvés dans Kjuup. Seuls les membres du projet peuvent inviter de nouveaux utilisateurs.",
  branch: "Branche",
  photo_video_media_lib: "Bibliothèque multimédia photo - vidéo",
  document: "Document",
  location: "Lieu",
  location_meeting: "Lieu / Réunion",
  all_member_of_project: "Tous les membres du projet",
  pending_request: "Invitations de projet en attente",
  no_pending_request: "Aucune demande en attente trouvée !",
  news_feed: "Fil d'actualités",
  user_info: "Info du groupe",
  leave_project: "Quitter le projet",
  media_link_docs: "Fichiers",
  search_chat: "Rechercher dans le chat",
  export_chat_group: "Exporter les données du groupe de discussion du mois dernier",
  request_complete_chat_history: "Demander l'historique complet du chat",
  leave_chat_group: "Quitter le groupe de discussion",
  add_user_project: "Ajouter un utilisateur",
  me: "Moi",
  max_open_one_to_one: "Actuellement, max. 2 discussions individuelles peuvent être ouvertes en parallèle dans les sections inférieure et supérieure. Au total, max. 4 discussions individuelles sont possibles.",
  are_you_sure_you_want_leave_chat: "Êtes-vous sûr de vouloir quitter ce groupe de discussion ?",
  create_group: "Créer un groupe",
  adding_members: "Ajout des membres...",
  creating_the_chat: "Création du chat...",
  finishing_setup: "Finalisation...",
  group_name: "Nom du groupe",
  by: "Par :",
  mandetory: "*obligatoire",
  delteed: "a supprimé son profil et a quitté le groupe de discussion.",
  deleted_direct: "a supprimé son profil et a quitté la discussion.",
  unhidden_message: "Si vous affichez les projets, ils peuvent être trouvés par tous les membres de Kjuup.",
  account_deleted: "Le compte a été supprimé.",
  refuse_company: "Êtes-vous sûr de vouloir refuser l'invitation de l'entreprise ?",
  follow_additional: "Suivre d'autres utilisateurs",
  f_add: "Suivez d'autres utilisateurs de Kjuup pour les rendre disponibles pour les messages directs.",
  c_inv: "Invitation(s) d'entreprise",
  invited_o_Company: "Vous avez été invité à rejoindre l'entreprise",
  refuse_companyX: "Êtes-vous sûr de vouloir refuser la demande de l'entreprise ?",
  a_Da: "Compte désactivé.",
  has_deactivated: "a désactivé son profil.",
  reactive: "a réactivé son profil.",
  juup_note: "*L'inscription avec un nom d'utilisateur n'est disponible que pour les membres de Kjuup+",
  username: "Nom d'utilisateur*",
  email_username: "E-mail/Nom d'utilisateur*",
  sPinText: "Veuillez fournir un code PIN de sécurité à 6 chiffres. Ce code PIN sera nécessaire en cas d'oubli de votre mot de passe et est obligatoire pour confirmer votre compte.",
  DeleteKjuupPlusText: "Voulez-vous vraiment supprimer votre profil ? Lorsque vous supprimez votre profil, toutes les connexions aux entreprises, projets et discussions seront supprimées.\n\nDans les 48h suivant la suppression du compte, vous pouvez réactiver votre compte en vous connectant avec votre nom d'utilisateur, mot de passe et code PIN.",
  reactive_text: "Votre compte a été supprimé. Veuillez cliquer sur Réactiver pour réactiver votre compte.",
  rac: "Réactiver",
  ac_ss: "Compte réactivé avec succès.",
  not_valid_pin: "Code PIN invalide",
  only_for_kjuup: "*La réinitialisation du mot de passe via le nom d'utilisateur et le code PIN n'est disponible que pour les membres Kjuup+.",
  resetPIN: "Réinitialiser le PIN",
  enter_current_pin: "Veuillez entrer votre PIN actuel",
  enter_new: "Entrer un nouveau PIN",
  pin_to_confirm: "Veuillez fournir le PIN pour confirmer.",
  change_username: "Réinitialiser le nom d'utilisateur",
  pp_not_match: "Le mot de passe et la confirmation du mot de passe ne correspondent pas",
  reactive_itself: "Vous avez réactivé votre profil.",
  has_deactivated_itself: "Vous avez désactivé votre profil.",
  more_than_two: "Actuellement, les messages directs ne peuvent être faits qu'avec 2 utilisateurs en parallèle.",
  Chats: "Messages directs",
  only_in_mobileL: "Les vidéos natives ne peuvent actuellement être téléchargées et publiées que via l'application mobile. Veuillez utiliser des liens vidéo de Youtube et Vimeo.",
  register_pin_text: "Veuillez choisir votre code PIN personnel à 6 chiffres. Ce code PIN sera nécessaire pour activer les fonctionnalités de réinitialisation du compte.",
  internal_project: "Interne",
  external_projects: "Externe",
  in_deacticted: "La section interne est désactivée.",
  create_article: "Créer un article",
  new_article_selection: "Créer un article pour le fil d'actualités externe",
  new_article_selection_internal: "Créer un article interne",
  active_trans_title: "Activer la traduction automatique ?",
  active_trans: "Lorsqu'elle est activée, tous les messages de chat entrants seront traduits dans la langue de l'application que vous avez sélectionnée.",
  disable_trans: "Voulez-vous vraiment désactiver la traduction automatique ?",
  allow_access_chat: "Afficher l'historique complet du chat",
  toggle_chat_history_on: "Voulez-vous vraiment que l'utilisateur voie l'historique complet du chat ?",
  toggle_chat_history_off: "Voulez-vous vraiment que l'utilisateur ne voie l'historique du chat qu'à partir du moment où il a rejoint ?",
  check_selected_settings: "Veuillez vérifier les paramètres de l'historique du chat pour tous les utilisateurs sélectionnés !",
  chat_from_start_have: "Vous avez rejoint ce groupe. L'historique du chat a été partagé.",
  chat_from_start_has: "a rejoint ce groupe. L'historique du chat a été partagé.",
  Address: "Adresse",
  read_by: "Lu par",
  deliver_to: "Livré à",
  remaining: "restant",
  message_info: "Info du message",
  request_to_join_only: "Demande de rejoindre",
  unfollow: "Ne plus suivre",
  company_username: "Nom d'utilisateur",
  month: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Août", "Sept", "Oct", "Nov", "Déc"],
  remove_my_admin_right: "Supprimer mes droits d'admin",
  makeEmp: "Voulez-vous vraiment supprimer les droits d'admin de l'entreprise de l'utilisateur ?",
  remove_my_self: "Voulez-vous vraiment supprimer les droits d'admin de l'entreprise de votre compte ?",
  makeAdmin: "Voulez-vous vraiment donner les droits d'admin de l'entreprise à l'utilisateur ?",
  remove_member: "Supprimer le membre",
  remove_following_confirm: "Voulez-vous vraiment retirer {name} de la liste des abonnements ?",
  remove_follower_confirm: "Voulez-vous vraiment retirer {name} de vos abonnés ? Si vous le/la retirez, il/elle ne sera pas informé(e).",
  do_you_really_want_to_remove: "Voulez-vous vraiment supprimer l'utilisateur de l'entreprise ?",
  invite_all: "Inviter tous les membres de l'entreprise",
  invite_all_members: "Inviter tous les membres",
  mems: "Tous les autres membres",
  dep_loc: "Département/Lieu/Équipe",
  depAdmin: "Admin du département",
  add_remove_admin: "Ajouter/Supprimer la position d'admin d'entreprise",
  add_remove_dep_admin: "Ajouter/Supprimer la position d'admin de département",
  remove_employees_dept: "Supprimer des employés de",
  want_to_join_dep: "L'utilisateur veut rejoindre le Département/Lieu/Équipe de l'entreprise.",
  you_invited: "Vous avez été invité à rejoindre le Département/Lieu/Équipe de l'entreprise.",
  dep_remove: "Voulez-vous vraiment supprimer les droits d'admin pour le département ou le lieu de l'utilisateur ?",
  add_dep: "Voulez-vous vraiment donner les droits d'admin pour le département ou le lieu à l'utilisateur ?",
  my_self_dep_remove: "Voulez-vous vraiment supprimer les droits d'admin de département de votre compte ?",
  member: "Membre",
  admin: "Admin",
  remove_project_admin: "Voulez-vous vraiment supprimer le membre du projet ?",
  remove_my_self_project: "Voulez-vous vraiment supprimer les droits d'admin ?",
  remove_member_admin_right: "Voulez-vous vraiment supprimer les droits d'admin de l'utilisateur ?",
  add_member_admin_right: "Voulez-vous vraiment ajouter les droits d'admin à l'utilisateur ?",
  add_remove_Poss: "Ajouter/Supprimer la position d'admin",
  forward: "Transférer",
  forward_to: "Transférer à...",
  edit: "Modifier",
  only_kjuup_plus_can: "Seules les entreprises Kjuup+ peuvent publier des articles.",
  add_images: "Ajouter une/des image(s)",
  Activity: "Activité",
  latest_messages: "Derniers messages",
  hours: "heures",
  minute: "minutes",
  seconds: "secondes",
  yesterday: "hier",
  last_week: "La semaine dernière",
  this_week: "Cette semaine",
  next_week: "la semaine prochaine",
  Last_month: "Le mois dernier",
  this_month: "Ce mois-ci",
  All: "Tout",
  register_plus: "Inscription Plus",
  select_files: "Sélectionner des fichiers",
  monthsFullName: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
  company_deploc_receivers_message: "Lien d'invitation au département de l'entreprise dans Kjuup. Veuillez cliquer sur le lien pour vous inscrire à Kjuup et rejoindre l'entreprise.",
  no_news: "Aucune actualité disponible",
  reminder: "Rappel",
  np_reminder: "Pas de tâches",
  move_to_reminder: "Déplacer vers Tâches",
  remove_reminder: "Voulez-vous vraiment supprimer ce message de la liste de vos tâches ?",
  remove_all_reminder: "Supprimer toutes les tâches",
  remove_all_confirm: "Voulez-vous vraiment supprimer tous les messages de la liste de vos tâches ?",
  remove_from_reminder: "Supprimer du rappel",
  prevent_email: "L'e-mail ne peut pas être utilisé comme nom d'utilisateur.",
  allow_noti: "Veuillez autoriser les notifications.",
  join_cap: "Rejoindre",
  pass_minimum: "**Le mot de passe nécessite 12 caractères, y compris une minuscule, une majuscule, un chiffre et un caractère spécial.",
  pass_error: "Veuillez vérifier les exigences du mot de passe",
  people_that_like_article: "Personnes qui aiment l'article.",
  people_who_like_article: "Personnes qui aiment votre article.",
  message_delete: "Ce message a été supprimé.",
  message_edited: "modifié",
  edit_message: "Modifier le message",
  edit_window_expired: "Les messages ne peuvent être modifiés que dans les 10 minutes suivant l'envoi.",
  message_edit_save: "Enregistrer",
  copy: "Copier",
  bookmark: "Signet",
  add_reaction: "Ajouter une réaction",
  delete_message: "Supprimer le message",
  more_options: "Plus d'options",
  info: "Infos",
  delete_message_confirm: "Voulez-vous vraiment supprimer ce message?",
  link_invite: "Inviter via un lien",
  ll_nkk: "Inviter sur Kjuup",
  selected: "Sélectionné",
  is_active: "Actif",
  inactive: "Inactif",
  last_online: "dernière connexion {{when}}",
  remove_user_l: "Supprimer",
  link_expire: "Chaque lien généré sera valide pendant 72 heures.",
  company_language: "Langue de l'entreprise",
  company_language_info: "La sélection de la langue sera utilisée pour toutes les confirmations par e-mail concernant l'entreprise.",
  s_image: "image",
  m_image: "images",
  removeMsg: "Appuyez pour supprimer",
  block: "Bloquer",
  unblock: "Débloquer",
  blocks: "Êtes-vous sûr de vouloir bloquer cet utilisateur ?",
  unblocks: "Êtes-vous sûr de vouloir débloquer cet utilisateur ?",
  bolcked_click_un_block: "Vous avez bloqué ce contact. Cliquez ici pour supprimer le blocage.",
  you_have_unblocked: "Vous avez débloqué ce contact.",
  you_blocked_contact: "Vous avez bloqué ce contact.",
  you_unblocked_contact: "Vous avez débloqué ce contact.",
  you_have_blocked: "Vous avez bloqué ce contact.",
  unblock_to_send: "Débloquer l'utilisateur pour envoyer un message.",
  pilot_text: "IA spécialisée pour les sujets de construction",
  startup_screen_label: "Écran de démarrage",
  startup_screen_info: "Choisissez l'écran qui s'ouvre au démarrage de Kjuup.",
  startup_screen_feed: "Home",
  startup_screen_messages: "Messages",
  startup_screen_saved: "Écran de démarrage mis à jour",
email_on: "Notification par e-mail pour les discussions",
  email_on_grp: "Notification par e-mail",
  article_email_on: "Notification par e-mail pour les articles",
  article_email_info: "Si vous activez les notifications par e-mail pour les articles internes, vous recevrez un e-mail lorsqu'un nouvel article interne est publié dans votre entreprise et votre département.",
  info_email_room: "Activez ou désactivez les notifications par e-mail pour ce projet.",
  todo_notification_info: "Vous serez averti dès qu'une nouvelle tâche vous est attribuée.",
  info_val: "Vous recevrez un e-mail si un nouveau message de discussion n'est pas lu dans un court délai. Vous pouvez le désactiver pour des projets ou des discussions spécifiques dans leurs paramètres ou dans les infos du groupe de discussion.",
  email_groups: "Activez ou désactivez les notifications par e-mail pour cette discussion.",
  add_update_email: "Ajouter/Mettre à jour l'e-mail",
  text_to_verifiy: "L'option \"Notification par e-mail pour les discussions\" ne peut être activée que si vous avez une adresse e-mail vérifiée enregistrée.",
  stored_email: "E-mail enregistré : ",
  verify_email: "Confirmation en attente !",
  join_call: "Rejoindre",
  call_is_started: "Appel en cours",
  start_chat: "Démarrer une discussion directe ?",
  project_rooms: "Projets",
  download_selected: "Télécharger",
  download_to_folder: "Enregistrer dans un dossier",
  download_as_zip: "Télécharger en ZIP",
  media_download_progress: "Téléchargement {current} sur {total}",
  media_downloaded_on: "Images téléchargées le {datetime}",
  docs_downloaded_on: "Documents téléchargés le {datetime}",
  media_auto_download: "Téléchargement automatique des médias",
  media_auto_download_hint: "Les nouvelles images et documents sont enregistrés à 20h00",
  media_auto_download_info: "Choisissez un dossier une seule fois. Les nouvelles images et documents de ce chat ou de ce projet y sont enregistrés automatiquement tous les jours à 20h00. Si Kjuup est fermé à ce moment-là, le téléchargement s'effectue à la prochaine ouverture de l'application.",
  media_auto_download_unsupported: "La sélection de dossier nécessite Chrome ou Edge",
  media_auto_download_continue: "Autoriser l'accès au dossier pour continuer",
  media_export_server: "Serveur d'export des médias",
  media_export_server_info: "Connectez un serveur WebDAV ou SFTP. Chaque chat et chaque projet peut alors exporter les nouveaux médias dans son propre dossier chaque soir à 20h00.",
  media_export_protocol: "Protocole",
  media_export_host: "Hôte",
  media_export_port: "Port",
  media_export_username: "Nom d'utilisateur",
  media_export_password: "Mot de passe",
  media_export_base_path: "Chemin de base (optionnel)",
  media_export_test: "Tester la connexion",
  media_export_test_ok: "Connexion réussie",
  media_export_test_fail: "Échec de la connexion",
  media_export_saved: "Connexion enregistrée",
  media_export_disconnect: "Déconnecter",
  media_export_disconnect_confirm: "Déconnecter ce serveur de fichiers ?",
  media_export_folder: "Export nocturne des médias",
  media_export_folder_placeholder: "/Projets/Alpha",
  media_export_nightly_hint: "Les nouvelles images, vidéos et documents sont envoyés à 20h00",
  media_export_nightly_info: "Les nouvelles images, vidéos et documents sont envoyés chaque soir à 20h00 vers le dossier du serveur de l'entreprise. L'application n'a pas besoin d'être ouverte.",
  media_export_admin_required: "Un serveur de fichiers doit être connecté dans l'Admin Panel.",
  media_export_readonly: "Export nocturne vers {path}",
  media_export_last_error: "Dernier export échoué",
  change: "Modifier",
  add_employee_confirm: "Êtes-vous sûr de vouloir ajouter cet utilisateur à l'entreprise ?",
  invalid_deeplink: "URL deeplink invalide. Paramètres requis manquants.",
  deeplink_error: "Impossible de traiter le deeplink. Veuillez réessayer plus tard.",
  reply: "Répondre",
  reply_enter: "Entrer la réponse...",
  reply_sent_successfully: "Réponse envoyée avec succès",
  reply_failed: "Échec de l'envoi de la réponse",
  reply_failed_generic: "Échec de l'envoi de la réponse. Veuillez réessayer.",
  replying_to_message: "Réponse au message",
  cancel_reply: "Annuler la réponse",
  voice_message: "Message vocal",
  send: "Envoyer",
  type_your_reply: "Tapez votre réponse...",
  
  // Auto-suggestion translations
  suggested_replies: "Réponses suggérées",
  suggestions_error: "Échec du chargement des suggestions",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Image — Cliquer pour charger",
  lazy_media_audio: "Message vocal — Cliquer pour charger",
  lazy_media_doc: "Document — Cliquer pour charger",
  lazy_media_video: "Vidéo — Cliquer pour charger",
  suggestion_loading_message: "Un instant. Votre texte est préparé individuellement pour vous.",
  loading_chat_message: "Chargement du chat...",
  
  // Manual ToDo translations
  extracting_message: "Extraction du message...",
  create_todo: "Créer une tâche",
  create_todo_confirmation: "Voulez-vous créer une tâche à partir de ce message?",
  todo_summary: "Résumé",
  todo_summary_placeholder: "Entrez le résumé de la tâche...",
  todo_date: "Date",
  todo_time: "Heure",
  deadline: "Échéance",
  todo_date_hint: "Laissez vide pour utiliser la date/heure du message d'origine",
  todo_created_success: "Tâche créée avec succès",
  todo_creation_failed: "Échec de la création de la tâche",
  create: "Créer",
  
  image: "image",
  images: "images",
  remove_all_images: "Supprimer toutes les images",
  remove_image: "Supprimer l'image",
  remove_document: "Supprimer le document",
  remove_recording: "Supprimer l'enregistrement",
  play_recording: "Lire l'enregistrement",
  upload_image: "Télécharger l'image",
  upload_document: "Télécharger le document",
  record_audio: "Enregistrer l'audio",
  stop_recording: "Arrêter l'enregistrement",
  stop_recording_text: "Arrêter l'enregistrement",
  please_remove_current_attachment: "Veuillez supprimer la pièce jointe actuelle pour",
  please_upload_image_file: "Veuillez télécharger un fichier image valide",
  please_upload_valid_document: "Veuillez télécharger un fichier document valide",
  searching_messages: "Recherche de messages...",
  loading_more: "Chargement en cours...",
  loading_more_users: "Chargement d'autres utilisateurs...",
  load_more_users: "Charger plus d'utilisateurs",
  no_more_users_to_load: "Plus d'utilisateurs à charger",
  no_messages_found: "Aucun message trouvé",
  try_different_keyword: "Essayez un mot-clé différent ou vérifiez votre orthographe.",
  search_messages: "Rechercher des messages, groupes de chat, projets et utilisateurs...",
  search_groups: "Groupes",
  search_chat_groups: "Groupes de chat",
  search_project_room: "Projet",
  search_messages_tab: "Messages",
  searching_groups: "Recherche de groupes...",
  searching_rooms: "Recherche de projets...",
  no_groups_found: "Aucun groupe trouvé",
  no_rooms_found: "Aucun projet trouvé",
  search_users_tab: "Utilisateurs",
  search_documents_tab: "Documents",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "Aucun fichier",
  no_documents_available: "Aucun document",
  searching_users: "Recherche d'utilisateurs...",
  no_users_found: "Aucun utilisateur trouvé",
  search_emails_tab: "E-mail",
  searching_emails: "Recherche d'e-mails...",
  no_emails_found: "Aucun e-mail trouvé",
  search_email_addresses_tab: "Adresses e-mail",
  search_email_content_tab: "Contenu e-mail",
  searching_email_content: "Recherche du contenu e-mail...",
  no_email_content_found: "Aucun contenu e-mail trouvé",
  search_email_attachments_tab: "Pièces jointes",
  searching_email_attachments: "Recherche de pièces jointes...",
  no_email_attachments_found: "Aucune pièce jointe trouvée",
  email_attachments_label: "Pièces jointes",
  searching_email_addresses: "Recherche d'adresses...",
  no_email_addresses_found: "Aucune adresse trouvée",
  search_email_filter_all: "Tous",
  search_email_filter_content: "Contenu",
  search_email_filter_addresses: "Adresses",
  search_email_filter_attachments: "Pièces jointes",
  search_email_filter_has_attachments: "Avec pièces jointes",
  search_email_filter_unread: "Non lus",
  search_email_combo_placeholder: "Dans les e-mails de (optionnel)…",
  search_email_combo_content_placeholder: "Rechercher dans ces e-mails…",
  search_email_combo_hint: "Recherche dans les e-mails de",
  search_email_combo_containing: "contenant",
  search_describe: "Décrivez ce que vous cherchez…",
  search_describe_examples_with_email: "ex. e-mails de ml@bl2020.com avec mot de passe · messages de Martin sur facture · utilisateur Martin Langen",
  search_intent_understood: "Recherche",
  search_intent_emails: "E-mails",
  search_intent_messages: "Messages",
  search_intent_user: "Utilisateur",
  search_submit: "Rechercher",
  email_subject_label: "Objet",
  email_body_label: "Corps",
  email_address_received: "Reçus",
  email_address_sent: "Envoyés",
  todo: "Tâches",
  np_todo: "Pas de tâches",
  move_to_todo: "Enregistrer comme tâche",
  remove_todo: "Voulez-vous vraiment supprimer cette tâche ?",
  remove_all_todo: "Supprimer toutes les tâches",
  remove_all_todo_confirm: "Voulez-vous vraiment supprimer toutes les tâches ?",
  add_to_todo: "Ajouter aux tâches",
  remove_from_todo: "Supprimer des tâches",
  read_more: "Lire la suite",
  show_less: "Voir moins",
  show_more: "Voir plus",
  audio: "Audio",
  video: "Vidéo",
  notification_schedule: "Horaire des notifications",
  notification_schedule_desc: "Vous ne recevrez des notifications push et e-mail que pendant les heures que vous choisissez. En dehors de ces heures, elles seront suspendues.",
  learn_more: "En savoir plus",
  allow_notifications: "Autoriser les notifications :",
  every_day: "Tous les jours",
  weekdays: "Jours ouvrables (du lundi au vendredi)",
  custom: "Personnalisé",
  monday: "Lundi",
  tuesday: "Mardi",
  wednesday: "Mercredi",
  thursday: "Jeudi",
  friday: "Vendredi",
  saturday: "Samedi",
  sunday: "Dimanche",
  notification_settings: "Notifications",
  notification_settings_saved: "Paramètres de notification enregistrés avec succès",
  notification_settings_error: "Échec de l'enregistrement des paramètres de notification",
  unavailability_note: "Note d'absence",
  unavailability_description: "Définissez une note d'absence. Tant qu'elle est active, la note est affichée dans tous vos chats et les notifications sont suspendues.",
  unavailability_start_date: "Date de début",
  unavailability_end_date: "Date de fin",
  unavailability_message: "Message",
  unavailability_message_hint: "Utilisez {endDate} comme espace réservé pour votre date de retour.",
  unavailability_replacement: "Contact de remplacement",
  unavailability_replacement_placeholder: "Saisir l'identifiant pour les demandes urgentes",
  unavailability_replacement_current: "Remplacement actuel",
  unavailability_replacement_hint: "Si défini, un lien pour contacter cette personne pour les questions urgentes sera affiché dans votre note d'absence.",
  unavailability_replacement_none: "Pas de remplacement (optionnel)",
  unavailability_contact_urgent: "Pour les demandes urgentes, contactez",
  unavailability_default_message: "Je suis actuellement absent(e) du bureau et n'ai pas accès à Kjuup. Je serai de nouveau disponible à partir du {endDate} et vous recontacterai à ce moment-là.",
  unavailability_save: "Enregistrer",
  unavailability_deactivate: "Désactiver",
  unavailability_active_until: "Actif jusqu'au",
  unavailability_saved: "Note d'absence enregistrée",
  unavailability_save_error: "Échec de l'enregistrement de la note d'absence",
  unavailability_deactivated: "Note d'absence désactivée",
  unavailability_end_date_required: "La date de fin est obligatoire",
  start_time_before_end_time: "L'heure de début doit être avant l'heure de fin",
  loading: "Chargement",
  disabled: "Désactivé",
  enable: "Activer",
  disable: "Désactiver",
  forwarded: "Transféré",
  message_forwarded: "Message transféré !",
  schedule_article_post: "Planifier la publication de l'article",
  date: "Date",
  scheduled_for_publication: "Planifié pour publication",
  article_will_be_published_on: "L'article sera publié le :",
  reset_selection: "Réinitialiser la sélection",
  error_loading_members: "Erreur lors du chargement des membres",
  please_fill_all_fields: "Veuillez remplir tous les champs",
  invalid_email: "Adresse e-mail invalide",
  member_added_successfully: "Membre ajouté avec succès",
  error_onboarding_user: "Erreur lors de l'ajout de l'utilisateur",
  error_creating_chat: "Erreur lors de la création de la discussion",
  error_creating_group: "Erreur lors de la création du groupe",
  new_group: "Nouveau groupe",
  please_select_or_enter_group_name: "Veuillez sélectionner un groupe ou entrer un nom de groupe",
  please_select_or_enter_room_name: "Veuillez sélectionner un projet ou entrer un nom de projet",
  error_creating_room: "Erreur lors de la création du projet",
  error_opening_chat: "Erreur lors de l'ouverture de la discussion",
  privacy_modal_text: "Sélectionnez \"Privé\" uniquement si la discussion ne contient aucun contenu professionnel pertinent pour le chef de projet.",
  not_private: "Non privé",
  private: "Privé",
  error_loading_groups: "Erreur lors du chargement des groupes",
  automatic_chat_export: "Export automatique du chat",
  automatic_chat_export_info: "Après activation, l'historique du chat sera automatiquement envoyé à l'adresse e-mail spécifiée chaque mois.",
  automatic_chat_export_no_email: "Pour activer l'export automatique du chat, vous devez d'abord ajouter une adresse e-mail. Vous pouvez ajouter votre adresse e-mail dans les paramètres personnels.",
  enter_email: "Entrer l'e-mail",
  export_to_email: "L'export va à l'e-mail suivant.",
  start_chat_button: "Nouveau message",
  matching_existing_chats: "Discussions existantes correspondantes",
  subject: "Sujet",
  add_subject: "Ajouter un sujet",
  chat_subject: "Sujet du chat :",
  set_project_room: "Définir le projet",
  matching_existing_project_rooms: "Projets existants correspondants",
  name_project_room: "Nom du projet",
  professional_or_private: "Professionnel ou privé",
  professional: "Professionnel",
  privacy_modal_text_updated: "Sélectionnez \"Privé\" uniquement si la discussion ne contient pas de contenu professionnel pertinent pour les chefs de projet. Les discussions privées ne sont pas visibles par les chefs de projet.",
  create_internal_chat: "Chat externe - ou interne ?",
  internal_chat_description: "Seuls les employés de votre entreprise peuvent être ajoutés aux discussions internes.",
  yes: "Oui",
  no: "Non",
  chat_is_being_created: "La discussion est en cours de création...",
  discard_article_confirm: "Voulez-vous vraiment abandonner les modifications de cet article ?",
  please_enter_article_title: "Veuillez d'abord entrer le titre de l'article.",
  please_add_mandatory_fields: "Veuillez ajouter tous les champs obligatoires",
  product_label: "Produit :",
  no_companies_found: "Aucune entreprise trouvée",
  visible_to_all_followers: "Visible pour tous les membres Kjuup",
  only_visible_to_employees: "Visible uniquement par les employés",
  something_went_wrong: "Quelque chose s'est mal passé, veuillez réessayer",
  please_select_department: "Veuillez sélectionner le département/lieu",
  schedule: "Planifier",
  please_select_future_date_time: "Veuillez sélectionner une date et une heure futures pour planifier l'article.",
  please_select_different_date_time: "Veuillez sélectionner une date ou une heure différente pour planifier l'article.",
  please_select_later_time: "Veuillez sélectionner une heure ultérieure à l'heure actuelle pour aujourd'hui.",
  unpin_article: "Désépingler l'article",
  pin_article: "Épingler l'article",
  and: "et",
  others: "autres",
  at: "à",
  mute: "Couper le son",
  unmute: "Rétablir le son",
  chat_muted_successfully: "Discussion mise en sourdine avec succès",
  chat_unmuted_successfully: "Sourdine de la discussion désactivée avec succès",
  mute_chat_confirm: "Voulez-vous vraiment mettre cette discussion en sourdine ? Vous ne recevrez plus de notifications pour les nouveaux messages.",
  unmute_chat_confirm: "Voulez-vous vraiment désactiver la sourdine de cette discussion ? Vous recevrez à nouveau des notifications pour les nouveaux messages.",
  please_select_group_to_forward: "Veuillez sélectionner un groupe pour transférer le message",
  record_not_found: "Enregistrement non trouvé !",
  please_select_position: "Veuillez sélectionner une position",
  delete_article_confirm: "Êtes-vous sûr de vouloir supprimer cet article ?",
  delete_company_service_confirm: "Êtes-vous sûr de vouloir supprimer le service de l'entreprise ?",
  block_translation_confirm: "Voulez-vous vraiment bloquer la traduction automatique dans les projets pour tous les membres de l'entreprise",
  unblock_translation_confirm: "Voulez-vous vraiment débloquer la traduction automatique dans les projets pour tous les membres de l'entreprise",
  please_select_file: "Veuillez sélectionner un fichier à télécharger",
  role_in_building_industry: "Rôle dans l'industrie du bâtiment*",
  invalid_email_address: "Adresse e-mail invalide",
  please_enter_password: "Veuillez entrer le mot de passe",
  password_change_email_sent: "Un e-mail a été envoyé à votre adresse e-mail Kjuup. Veuillez confirmer votre nouveau mot de passe en cliquant sur le lien de confirmation dans l'e-mail.",
  please_enter_username: "Veuillez entrer le nom d'utilisateur",
  username_same_as_before: "Le nom d'utilisateur ne peut pas être le même qu'avant",
  profile_deleted_successfully: "Profil supprimé avec succès",
  hardware_requirements: "Configuration requise",
  hardware_requirements_list: "• 4 Go de RAM<br/>• Vitesse CPU min. 2 GHz<br/>• Windows 7 ou supérieur / toutes versions macOS",
  submitting: "Envoi en cours...",
  signing_in: "Connexion en cours...",
  please_enter_service_name: "Veuillez entrer le nom du service",
  something_went_wrong_error: "Aïe ! Quelque chose s'est mal passé...",
  something_went_wrong_try_again: "Désolé, quelque chose s'est mal passé. Réessayez",
  position_label: "Position :",
  loading_room: "Chargement du projet...",
  navigating_to_room: "Navigation vers le projet",
  loading_chat: "Chargement de la discussion...",
  translate: "Traduire",
  show_original: "Afficher l'original",
  saving: "Enregistrement...",
  language_selection_info: "La sélection de la langue est utilisée pour toutes les confirmations par e-mail liées à l'entreprise.",
  // Navigation bar labels
  nav_call: "Appel",
  nav_home: "Accueil",
  nav_messages: "Messages",
  nav_todo: "Tâches",
  nav_rooms: "Projets",
  nav_all_rooms: "Tous les projets",
  pinned_rooms_max: "Vous pouvez épingler jusqu'à 10 projets.",
  pinned_room_unpin: "Désépingler",
  pinned_rooms_drop: "Glissez votre projet ici pour une sélection rapide",
  nav_profile: "Profil",
  nav_company: "Entreprise",
  nav_company_documents: "Documents de l'entreprise",
  nav_logout: "Déconnexion",
  // Create message dialog
  add_member_title: "Ajouter un membre",
  continue_btn: "Continuer",
  search_placeholder: "Rechercher",
  no_members_found: "Aucun membre trouvé",
  no_groups_found: "Aucun groupe trouvé",
  no_rooms_found: "Aucun projet trouvé",
  unnamed_group: "Groupe sans nom",
  unnamed_room: "Projet sans nom",
  all_members: "Tout",
  room_label: "Projet :",
  subject_label: "Sujet :",
  no_members: "Aucun membre",
  // Loading states for room creation
  creating_structure: "Création de votre structure",
  opening_chat: "Ouverture de la discussion",
  please_wait: "Veuillez patienter...",
  // ToDo page translations
  loading_todo: "Chargement de ToDo...",
  task_updated: "Tâche mise à jour",
  error_updating_task: "Erreur lors de la mise à jour de la tâche",
  task_deleted: "Tâche supprimée",
  error_deleting_task: "Erreur lors de la suppression de la tâche",
  delete_task_confirm: "Êtes-vous sûr de vouloir supprimer cette tâche ?",
  delete_multiple_tasks_confirm: "Voulez-vous vraiment supprimer {count} ToDo ?",
  delete_selected_count: "Supprimer ({count})",
  todo_multi_delete: "Supprimer plusieurs",
  todo_multi_delete_hint: "Sélectionner des ToDo à supprimer",
  todos_deleted_count: "{count} ToDo supprimés",
  pro_todo_delete_previous: "Tout supprimer",
  pro_todo_previous_title: "Supprimer {{n}} tâches en retard ?",
  pro_todo_previous_text: "Toutes vos tâches ouvertes des jours précédents seront supprimées.",
  pro_todo_previous_skipped: "{{n}} attribuées par d’autres sont conservées.",
  pro_todo_previous_none: "Aucune tâche en retard",
  pro_todo_previous_none_own: "Les tâches en retard vous ont été attribuées par d’autres et seules ces personnes peuvent les supprimer.",
  todos_deleted_partial: "{ok} ToDo supprimés, {fail} échec",
  delete_only_own: "Vous ne pouvez supprimer que les ToDo que vous avez créés",
  description_label: "Description",
  description_placeholder: "Entrer la description...",
  date_time_label: "Date et heure",
  save_hint: "Ctrl+Entrée pour enregistrer, Échap pour annuler",
  edit_label: "Modifier",
  delete_label: "Supprimer",
  todo_list_title: "Tâches",
  tasks_count: "tâches",
  search_placeholder_todo: "Rechercher...",
  select_task_to_open_chat: "Sélectionnez une tâche pour ouvrir la discussion",
  today: "Aujourd'hui",
  yesterday: "Hier",
  time_suffix: "", // Empty for French (24h format doesn't need suffix)
  from_chat: "Source ToDo",
  assigned_to: "Assigné à",
  assign_users: "Assigner des utilisateurs",
  assigned_users: "Utilisateurs assignés :",
  no_users_assigned: "Aucun utilisateur assigné",
  assign: "Assigner",
  assign_to: "Assigner à...",
  navigate_to_chat: "Aller au chat",
  navigate_to_email: "Aller à l'e-mail",
  show_original_message: "Afficher la source",
  hide_original_message: "Masquer la source",
  status_pending: "En attente",
  status_in_progress: "En cours",
  status_completed: "Terminé",
  show: "Afficher",
  close: "Fermer",
  // Additional ToDo translations
  todo_beta: "BETA",
  todo_project_label: "Projet:",
  todo_chat_label: "Chat:",
  todo_assigned_by: "Assigné par:",
  todo_assigned_push: "ToDo assigné :",
  todo_assigned_push_empty: "Un nouveau ToDo vous a été assigné.",
  todo_clear_all: "Tout effacer",
  todo_unknown: "Inconnu",
  filter_all: "Tous",
  filter_assigned_to_me: "Mes tâches",
  filter_assigned_by_me: "Délégué",
  completed_by: "Terminé par:",
  verify_completion: "Vérifier",
  back_into_in_progress: "Retour en cours",
  unassign_todo: "Désassigner la tâche",
  unassign_label: "Désassigner",
  me: "Moi",
  search_or_select_project: "Rechercher ou sélectionner un projet...",
  // Confirmed ToDo and History translations
  status_confirmed: "Confirmé",
  history: "Historique",
  marked_as: "Marqué comme",
  at_date: "le",
  at_time: "à",
  time_suffix: "",
  all_todos: "Tâches ouvertes",
  confirmed_todos: "Tâches confirmées",
  filter_pending: "En attente",
  filter_confirmed: "Confirmé",
  my_list: "Ma Journée",
  todo_adjust_list: "Modifier la liste",
  apply: "Appliquer",
  move_back_in_progress: "Remettre en cours",
  no_history_yet: "Aucun historique",
  todo_status_updated: "Statut de la tâche mis à jour de {from} à {to}",
  todo_status_updated_from: "de",
  todo_status_updated_to: "à",
  // Log description translations
  log_todo_created: "ToDo créé",
  log_todo_confirmed: "ToDo confirmé",
  log_todo_deleted: "ToDo supprimé",
  log_todo_updated: "ToDo mis à jour",
  log_description_updated: "Description mise à jour",
  log_deadline_updated: "Date limite mise à jour",
  log_assigned_to: "Assigné à {name}",
  log_unassigned_from: "Désassigné de {name}",
  log_assignment_added: "Assignation ajoutée : {name}",
  log_assignment_removed: "Assignation supprimée : {name}",
  log_status_updated: "Statut modifié de {from} à {to}",
  log_status_changed: "Statut modifié",
  log_status_changed_to: "Statut modifié en {status}",
  log_changed_status_to: "Statut changé en :",
  log_for_user: "pour l'utilisateur :",
  log_user_updated_status: "L'utilisateur a mis à jour le statut du ToDo",
  log_changed_date_to: "Date modifiée en :",
  log_changed_description_to: "Description modifiée en :",
  log_moved_to: "Déplacé vers {status}",
  // ToDo filter translations
  todo_filters: "Filtres",
  todo_filter_by_project: "Filtrer par projet",
  todo_status: "Statut",
  todo_assignment: "Affectation",
  todo_filter_by_user: "Filtrer par personne affectée",
  todo_active_filters: "Filtres actifs :",
  todo_progress: "Progrès",
  todo_my_list_empty: "Votre journée est vide",
  todo_my_list_empty_hint: "Cliquez sur le bouton ci-dessus pour ajouter des tâches",
  create_poll: "Sondage",
  poll_question_label: "QUESTION",
  poll_question_placeholder: "Posez une question",
  poll_options_label: "OPTIONS",
  poll_option: "Option",
  poll_add_option: "Ajouter une option",
  poll_allow_multiple: "Autoriser plusieurs réponses",
  poll_multiple_allowed: "Sélectionnez une ou plusieurs options",
  poll_select_option: "Sélectionnez une option",
  poll_view_votes: "Voir les votes",
  poll_vote_singular: "vote",
  poll_vote_plural: "votes",
  poll_votes: "Votes du sondage",
  poll_no_votes_yet: "Pas encore de votes",
  transcript_label: "Transcription",
  ai_generated_transcription: "Transcription générée par IA",
  transcript_start: "Transcrire le message vocal",
  transcript_transcribing: "Transcription...",
  transcript_show: "Afficher la transcription",
  transcript_hide: "Masquer la transcription",
  transcript_redo: "Refaire la transcription",
  transcript_failed: "Échec de la transcription",
  transcript_no_result: "Aucune transcription reçue",
  transcript_step_listening: "Écoute du message vocal...",
  transcript_step_processing: "Transcription en cours...",
  transcript_step_creating: "Création du texte...",
  ai_transcript_tab: "AI-Transcription",
  ai_transcript_info: "Disponible uniquement pour les messages vocaux créés après le 09.03.2026.",
  no_transcript_available: "Aucune transcription disponible.",
  transcript_more: "...plus",
  transcript_less: "...moins",
  ki_transcript_voice_message: "KI-Transcription du message vocal",
  ki_image_analysis: "Analyse d'image assistée par IA",
  type_message: "Tapez un message",
  email_tab_messages: "Messages",
  email_tab_email: "E-Mail",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "Comptes e-mail",
  email_connect_gmail: "Connecter Gmail",
  email_connect_outlook: "Connecter Outlook",
  email_no_accounts: "Aucun compte e-mail connecté",
  email_no_accounts_hint: "Connectez un compte e-mail dans les paramètres de votre profil",
  email_no_messages: "Aucun e-mail",
  email_from: "De",
  email_to: "À",
  email_subject: "Objet",
  email_disconnect: "Déconnecter",
  email_disconnect_confirm: "Êtes-vous sûr de vouloir déconnecter ce compte e-mail ? Tous les e-mails synchronisés seront supprimés.",
  email_account_disconnected: "Compte e-mail déconnecté avec succès",
  email_account_disconnect_failed: "Échec de la déconnexion du compte",
  email_connecting: "Connexion...",
  email_account_connected: "Compte connecté avec succès",
  email_connection_error: "Problème de connexion",
  email_connection_error_hint: "Ce compte n'a pas pu être synchronisé. Reconnectez-vous pour rétablir la réception des e-mails.",
  email_reconnect: "Reconnecter",
  email_reconnect_banner: "Un ou plusieurs comptes e-mail doivent être reconnectés.",
  email_reconnect_manage: "Corriger dans les paramètres",
  email_connection_warning: "La connexion e-mail de {email} ne fonctionne plus correctement. Reconnectez-vous pour continuer à recevoir de nouveaux e-mails.",
  email_connection_warning_multi: "Les connexions e-mail de {emails} ne fonctionnent plus correctement. Reconnectez-vous pour continuer à recevoir de nouveaux e-mails.",
  email_connected_accounts: "Comptes connectés",
  email_sync_info: "Lors de la connexion d'un compte e-mail, les e-mails du dernier mois sont synchronisés par défaut. Vous pouvez étendre la période de synchronisation ci-dessous.",
  email_sync_3_months: "Synchroniser les 3 derniers mois",
  email_sync_6_months: "Synchroniser les 6 derniers mois",
  email_syncing: "Synchronisation...",
  email_sync_already_done: "{months} mois déjà synchronisés",
  email_sync_more: "Synchroniser plus de mois",
  email_sync_all_done: "Tous les mois synchronisés",
  email_syncing_account: "Synchronisation du compte en cours, cela peut prendre quelques minutes…",
  email_signature: "Signature",
  email_signature_placeholder: "Entrez votre signature e-mail...",
  email_signature_save: "Enregistrer",
  email_signature_saved: "Enregistré",
  email_add_account: "Ajouter un compte",
  email_folder_inbox: "Boîte de réception",
  email_folder_spam: "Spam",
  email_folder_drafts: "Brouillons",
  email_folder_sent: "Éléments envoyés",
  email_folder_deleted: "Éléments supprimés",
  email_folder_archive: "Archive",
  email_folder_outbox: "Boîte d'envoi",
  email_custom_folders: "Dossiers",
  email_create_folder: "Nouveau dossier",
  email_delete_folder: "Supprimer le dossier",
  email_folder_name_placeholder: "Nom du dossier",
  email_folder_created: "Dossier créé",
  email_folder_deleted: "Dossier supprimé",
  email_move_to: "Déplacer vers",
  email_moved_to_folder: "Déplacé dans le dossier",
  email_move_to_inbox: "Déplacer vers la boîte de réception",
  email_confirm_delete_folder: "Voulez-vous vraiment supprimer ce dossier ?",
  email_refresh: "Actualiser",
  email_go_to_settings: "Aller aux paramètres",
  email_date: "Date",
  email_reply: "Répondre",
  email_forward: "Transférer",
  email_copy_text: "Copier le texte",
  email_text_copied: "Copié !",
  email_text_copy_failed: "Impossible de copier le texte.",
  email_delete: "Supprimer",
  email_not_spam: "Pas un spam",
  email_not_spam_success: "E-mail déplacé vers la boîte de réception.",
  email_not_spam_failed: "Échec du déplacement vers la boîte de réception.",
  email_delete_confirm: "Êtes-vous sûr de vouloir supprimer cet e-mail ?",
  email_delete_from_folder: "Êtes-vous sûr de vouloir supprimer depuis {folder} ?",
  email_delete_permanent_from_folder:
    "Êtes-vous sûr de vouloir supprimer définitivement depuis {folder} ? Cette action est irréversible.",
  email_save_draft_confirm: "Voulez-vous enregistrer cet e-mail comme brouillon ?",
  email_save_draft: "Enregistrer le brouillon",
  email_discard: "Supprimer",
  email_back_to_compose: "Revenir à la rédaction",
  email_draft_saved: "Brouillon enregistré.",
  email_saving_draft: "Enregistrement du brouillon...",
  email_draft_save_failed: "Échec de l'enregistrement du brouillon.",
  email_loading: "Chargement des e-mails...",
  email_imap_title: "IMAP",
  email_imap_hint: "Connectez n'importe quel compte e-mail via IMAP.",
  email_imap_user: "E-mail",
  email_imap_password: "Mot de passe",
  email_imap_connect_btn: "Connecter le compte IMAP",
  email_imap_required: "Veuillez saisir l'e-mail et le mot de passe.",
  email_imap_failed: "Échec de la connexion IMAP.",
  email_imap_manual_toggle: "Paramètres manuels du serveur",
  email_imap_host: "Serveur IMAP (ex. imap.ionos.de)",
  email_imap_port: "Port",
  email_imap_incoming: "Courrier entrant (IMAP)",
  email_smtp_outgoing: "Courrier sortant (SMTP)",
  email_smtp_host: "Serveur SMTP (ex. smtp.ionos.de)",
  email_smtp_port: "Port",
  email_send_btn: "Envoyer",
  email_sent: "E-mail envoyé.",
  email_sending: "Envoi de l'e-mail...",
  deleting_emails: "Suppression de l'e-mail...",
  marking_unread: "Marquage comme non lu...",
  email_send_failed: "Échec de l'envoi de l'e-mail.",
  email_compose_to_required: "Le destinataire (À) est requis.",
  email_compose_body_required: "Veuillez saisir un objet ou un corps de message.",
  email_original_message: "Message original",
  email_forwarded_message: "Message transféré",
  email_archived: "Archived",
  email_mark_spam: "Marquer comme spam",
  email_marked_spam: "Marqué comme spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "Sélectionner",
  email_attachment_singular: "Pièce jointe",
  email_attachment_plural: "Pièces jointes",
  email_back: "Retour",
  email_download: "Télécharger",
  email_close: "Fermer",
  email_preview: "Aperçu",
  email_preview_not_available: "Aperçu non disponible",
  email_preview_failed: "Aperçu non disponible",
  select_attachments: "Sélectionner les pièces jointes",
  email_loading_preview: "Chargement de l'aperçu...",
  email_mark_unread_failed: "e-mail(s) n'ont pas pu être marqué(s) comme non lu(s).",
  email_delete_failed: "e-mail(s) n'ont pas pu être supprimé(s).",
  filter_all: "Tous",
  filter_email: "E-Mail",
  filter_reports: "Rapports",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "Messages directs",
  my_notes: "My Space",
  filter_internal_groups: "Chats de groupe internes",
  filter_external_groups: "Chats de groupe externes",
  filter_group_chats: "Chats de groupe",
  filter_groups_internal: "Internes",
  filter_groups_external: "Externes",
  filter_unread_only: "Non lus uniquement",
  room_daily_briefing_label: "Rapport individuel pour ce projet",
  room_daily_briefing_info: "Lorsqu'il est activé, un rapport pour ce projet est généré toutes les 24 heures à l'heure indiquée dans vos paramètres personnels — mais uniquement s'il y a eu de l'activité pendant cette période.",
  email_select_all: "Tout sélectionner",
  email_deselect_all: "Tout désélectionner",
  email_reply_all: "Répondre à tous",
  email_reply_placeholder: "Tapez votre réponse...",
  email_forward_placeholder: "Ajoutez un message...",
  email_edit_draft: "Modifier le brouillon",
  email_attach: "Joindre",
  email_attachment_from_original: "Du message d'origine",
  email_remove: "Supprimer",
  email_drop_files: "Déposez les fichiers à joindre",
  email_loading_attachments: "Chargement des pièces jointes...",
  email_archive: "Archiver",
  mark_unread: "Marquer comme non lu",
  mark_read: "Marquer comme lu",
  email_all_accounts: "Tous les comptes",
  email_error: "Erreur",
  email_delete_email_failed: "Échec de la suppression de l'e-mail.",
  enter_url: "Entrez l'URL",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'S’abonner maintenant',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: '1 MOIS D\'ESSAI GRATUIT',
  kjuup_io_trial_title: 'Débloquez Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connectez votre e-mail, recevez des suggestions de réponse basées sur l\'IA et synchronisez automatiquement vos tâches avec votre calendrier.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'Aucun paiement aujourd\'hui. Aucune donnée de carte bancaire n\'est demandée avant le début de l\'abonnement payant.',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Commencer gratuitement – sans risque',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'Gérez tous vos comptes e-mail directement dans Kjuup',
  kjuup_io_feature_assign: 'Attribuez automatiquement e-mails et pièces jointes aux projets',
  kjuup_io_feature_ai: 'L\'IA rédige les réponses – vous confirmez seulement',
  kjuup_io_feature_tasks: 'Tâches et calendrier toujours à jour automatiquement',
  kjuup_io_choose_plan: 'Choisir votre forfait',
  kjuup_io_plan_monthly: 'Mensuel',
  kjuup_io_plan_yearly: 'Annuel',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Sécurisé par Stripe · résiliable à tout moment',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'Paiement reçu. Activation de votre abonnement…',
  kjuup_io_toast_activating_soon: 'Paiement reçu. Votre abonnement sera activé sous peu.',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'Aucune donnée de carte bancaire n\'est demandée avant le début de l\'abonnement payant.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: '{count} heures restantes',
  kjuup_io_trial_left_hour: '1 heure restante',
  kjuup_io_trial_left_minutes: '{count} minutes restantes',
  kjuup_io_trial_left_minute: '1 minute restante',
  kjuup_io_trial_left_seconds: '{count} secondes restantes',
  kjuup_io_trial_left_second: '1 seconde restante',
  kjuup_io_trial_ending_now: 'Votre essai se termine…',
  kjuup_io_request_timeout: 'La connexion a expiré. Veuillez réessayer.',
  kjuup_io_info_days_free: '{days} jours entièrement gratuits – votre abonnement ne commence qu\'après l\'essai.',
  kjuup_io_discount_total: 'Votre remise : {percent} %',
  kjuup_io_discount_company: '{company} : {percent} %',
  kjuup_io_discount_personal: 'Personnelle : {percent} %',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: 'Fermer',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'Votre essai gratuit est terminé',
  kjuup_io_trial_ended_body: 'Abonnez-vous à Kjuup.io pour continuer à utiliser l\'e-mail et les autres fonctionnalités premium.',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'Votre essai gratuit a commencé',
  kjuup_io_toast_trial_fail: 'Impossible de démarrer l\'essai gratuit',
  kjuup_io_trial_try_month: 'Essayez Kjuup.io gratuitement pendant un mois.',
  kjuup_io_per_month: 'par mois',
  kjuup_io_price_month_line: '{price} / mois',
  kjuup_io_billed_annually_amount: '{price} facturés annuellement',
  kjuup_io_save_yearly: 'Économisez {pct} % avec la facturation annuelle.',
  kjuup_io_save_amount_year: 'Économisez {price} par an',
  kjuup_io_savings_pct: '{pct} % d\'économie',
  kjuup_io_features_title: 'Ce que vous obtenez :',
  kjuup_io_info_one_month_free: 'Un mois gratuit',
  kjuup_io_info_plan_after_trial: 'Votre abonnement sélectionné commence après l\'essai.',
  kjuup_io_info_cancel_trial: 'Annulez à tout moment pendant l\'essai.',
  kjuup_io_info_no_card: 'Aucune carte bancaire requise – commencez immédiatement, sans saisir de données de paiement.',
  kjuup_io_info_cancel_anytime: 'Résiliable à tout moment – sans engagement, sans risque.',
  kjuup_io_cta_plan_begins: 'Votre forfait sélectionné commence après l\'essai gratuit.',
  kjuup_io_billing_period_aria: 'Période de facturation',
  kjuup_io_subscription_info_title: 'Informations sur l\'abonnement',
  kjuup_io_first_payment_on: 'Premier paiement le {date}.',
  kjuup_io_renews_on: 'Renouvellement le {date}.',
  kjuup_io_toast_card_saved: 'Moyen de paiement enregistré. Le prélèvement aura lieu à la fin de l\'essai.',
  calendar_sync_info: 'Synchronisez automatiquement tous les ToDos Kjuup avec votre calendrier.',
  calendar_no_accounts: 'Aucun calendrier connecté.',
  article_new_badge: 'NOUVEAU',
  article_new_posts: '{0} nouvelles publications',
  documents: 'Documents',
  add_documents: 'Ajouter des documents',
  no_preview_available: 'Aucun aperçu disponible',
  no_preview_hint: 'Ce type de fichier ne peut pas être prévisualisé, mais il sera tout de même envoyé.',
  max_documents_reached: 'Vous pouvez joindre jusqu\'à 10 documents à la fois.',
  open_file: 'Ouvrir le fichier',
  twofa_title: 'Double authentification',
  twofa_method_totp: 'Application d\'authentification',
  twofa_method_sms: 'SMS',
  twofa_method_email: 'E-mail',
  twofa_enter_app: 'Saisis le code à 6 chiffres de ton application d\'authentification.',
  twofa_enter_sms: 'Saisis le code à 6 chiffres que nous avons envoyé par SMS.',
  twofa_enter_email: 'Saisis le code à 6 chiffres que nous avons envoyé à ton e-mail.',
  twofa_resend: 'Renvoyer le code',
  twofa_try_another: 'Essayer une autre méthode',
  twofa_remember_device: 'Ne plus demander sur cet appareil pendant 30 jours',
  twofa_sent: 'Nous avons envoyé un code.',
  twofa_invalid_code: 'Ce code est incorrect. Réessaie.',
  twofa_something_wrong: 'Une erreur s\'est produite. Réessaie.',
  twofa_method_unavailable: 'Cette méthode n\'est pas disponible.',
  twofa_on_desc: 'La double authentification est activée. Tu auras besoin d\'un code à chaque connexion.',
  twofa_off_desc: 'Ajoute une deuxième étape après ton mot de passe. Les applications d\'authentification sont les plus sûres.',
  twofa_methods: 'Méthodes',
  twofa_on: 'Activé',
  twofa_add: 'Ajouter',
  twofa_default_method: 'Méthode par défaut',
  twofa_default: 'Par défaut',
  twofa_turn_off: 'Désactiver',
  twofa_disable_hint: 'Saisis ton mot de passe et un code actuel pour désactiver la double authentification.',
  twofa_disable_need: 'Saisis ton mot de passe et un code de vérification.',
  twofa_code_placeholder: 'Code à 6 chiffres ou code de secours',
  twofa_send_code: 'Envoyer un code',
  twofa_primary_updated: 'La méthode par défaut a été mise à jour.',
  twofa_disabled: 'La double authentification est maintenant désactivée.',
  twofa_enabled: 'La double authentification est maintenant activée.',
  twofa_totp_help: 'Scanne ce QR code avec Google Authenticator, Authy ou 1Password. Tu peux aussi saisir la clé manuellement.',
  twofa_secret_copied: 'Clé copiée',
  twofa_sms_help: 'Saisis ton numéro au format international. Nous enverrons un code à 6 chiffres par SMS.',
  twofa_email_help: 'Nous enverrons un code à 6 chiffres à l\'e-mail de ton compte.',
  twofa_backup_title: 'Codes de secours',
  twofa_backup_help: 'Range ces codes à usage unique en lieu sûr. Chaque code peut servir une fois si tu perds ton téléphone.',
  twofa_copy_codes: 'Copier les codes',
  twofa_codes_copied: 'Codes de secours copiés',
  twofa_regenerate: 'Obtenir de nouveaux codes de secours',
  twofa_regenerate_hint: 'Cela remplace les codes de secours inutilisés. Saisis ton mot de passe et un code actuel.',
  twofa_backup_remaining: '{n} codes de secours inutilisés restants',
  twofa_new_codes: 'Nouveaux codes de secours',
  twofa_sms_unavailable: 'Les codes par SMS ne sont pas encore disponibles.',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "Les tâches Kjuup qui te sont assignées sont copiées dans un projet « Kjuup » de ton Todoist. Les modifications faites dans Todoist ne sont pas recopiées.",
  todoist_connect: "Connecter Todoist",
  todoist_connected: "Todoist connecté",
  todoist_connect_failed: "Échec de la connexion à Todoist",
  todoist_disconnect: "Déconnecter",
  todoist_disconnected: "Todoist déconnecté",
  todoist_disconnect_confirm: "Déconnecter Todoist ? Les tâches déjà présentes dans Todoist restent. La synchronisation s’arrête.",
  todoist_sync_now: "Synchroniser",
  todoist_syncing: "Synchronisation…",
  todoist_sync_done: "Synchronisation terminée",
  todoist_sync_failed: "Échec de la synchronisation",
  todoist_auth_error: "Reconnecte Todoist pour continuer la synchronisation.",
  todoist_last_sync: "Dernière synchronisation",
  todoist_not_connected: "Todoist n’est pas connecté",
  todoist_auth_url_failed: "Impossible d’ouvrir la page d’autorisation Todoist.",
  recommend_text: "Rejoins Kjuup pour rester connecté et garder ta communication organisée. Réunis tes canaux, range tes messages dans les bons projets et commence chaque matin avec un résumé et tes tâches – le tout synchronisé avec les applis que tu utilises déjà. Commence gratuitement :",
  pro_auth_signin_title: 'Bon retour',
  pro_auth_signin_sub: 'Connectez-vous avec votre e-mail professionnel.',
  pro_auth_email_or_username: 'E-mail ou nom d\'utilisateur',
  pro_auth_email_placeholder: 'nom@entreprise.fr',
  pro_auth_forgot_password: 'Mot de passe oublié ?',
  pro_auth_create_account: 'Créer un compte',
  pro_auth_show_password: 'Afficher le mot de passe',
  pro_auth_hide_password: 'Masquer le mot de passe',
  pro_auth_register_sub: 'Nous vous enverrons un lien pour confirmer votre e-mail.',
  pro_auth_register_plus_sub: 'Choisissez un nom d\'utilisateur et un mot de passe. Ensuite, vous définirez votre PIN de sécurité.',
  pro_auth_check_credentials: 'Vérifiez votre e-mail et votre mot de passe',
  pro_news_export_pdf: 'Exporter en PDF',
  pro_news_pdf_failed: 'Le PDF n\'a pas pu être créé.',
  pro_news_pdf_attachments: 'Pièces jointes',
  pro_news_pdf_video: 'Vidéo',
  pro_auth_forgot_sub: 'Saisissez votre e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.',
  pro_auth_send_link: 'Envoyer le lien de réinitialisation',
  pro_auth_plus_reset: 'Réinitialiser avec le PIN',
  pro_auth_show_pin: 'Afficher le PIN',
  pro_auth_hide_pin: 'Masquer le PIN',
  v2_auth_plus_only: 'Kjuup+ uniquement',
  room_action_media: "Fichiers",
  room_tab_overview: "Aperçu",
  room_tab_history: "Historique",
  chat_info_media: "Fichiers",
  messages: "messages",
  pro_todo_project_required: "Veuillez choisir un projet",
  pro_todo_choose_project: "Pour quel projet est cette tâche ?",
  cockpit_report_delete_confirm: "Supprimer ce rapport quotidien ?",
  cockpit_report_deleted: "Rapport quotidien supprimé",
  cockpit_tab_company: "Entreprise",
  cockpit_bookmarked_priorities: "Tâches mises de côté",
  cockpit_load_error: "Le cockpit n'a pas pu être chargé.",
  cockpit_retry: "Réessayer",
  cockpit_yesterday: "Hier",
  cockpit_greeting_morning: "Bonjour",
  cockpit_greeting_day: "Bon après-midi",
  cockpit_greeting_evening: "Bonsoir",
  cockpit_assistant_q_open: "Qu'y a-t-il d'ouvert aujourd'hui ?",
  cockpit_assistant_q_summarize: "Résume le chat {{room}}",
  cockpit_assistant_q_overdue: "Quelles tâches sont en retard ?",
  cockpit_assistant_new: "{{n}} nouveau(x)",
  cockpit_assistant_important: "{{n}} important(s)",
  cockpit_assistant_title: "Assistant Kjuup",
  cockpit_assistant_hint: "Touchez et posez une question",
  room_overview_priority_no_detail: "Le rapport ne donne pas plus de détails sur cette priorité.",
  room_overview_priority_from: "Source : {{name}}",
  room_overview_priority_open_task: "Ouvrir la tâche",
  cockpit_priority_position: "{{index}} sur {{total}} priorités",
  room_overview_today_title: "Important aujourd'hui",
  room_overview_all_tasks: "Tout",
  room_overview_tasks_empty: "Aucune échéance ni tâche ouverte",
  room_overview_appointments_empty: "Aucun rendez-vous à venir",
  room_overview_no_priorities: "Aucune priorité ouverte dans le dernier rapport.",
  cockpit_report_top5: "Top 5 des priorités",
  cockpit_report_todo_created: "Tâche créée",
  cockpit_report_source_missing: "Le message source est introuvable.",
  delete_bookmarked_priority_confirm: "Voulez-vous vraiment supprimer cette tâche mise de côté ?",
  cockpit_report_create_todo: "Créer une tâche",
  cockpit_priorities_deleting: "Suppression en cours …",
  cockpit_priorities_select: "Supprimer plusieurs",
  cockpit_report_none: "Aucune entrée.",
  cockpit_priorities_delete_confirm: "Voulez-vous vraiment supprimer {count} tâches mises de côté ?",
  cockpit_priorities_delete_failed: "{count} tâches n'ont pas pu être supprimées",
  cockpit_priorities_deleted: "{count} tâches supprimées",
  cockpit_priorities_selected: "{count} sélectionnée(s)",
  cockpit_channel_connected: "Connecté",
  cockpit_channel_not_connected: "Non connecté",
  cockpit_channel_connect: "Connecter",
  cockpit_channel_chat: "Chat Kjuup",
  cockpit_channel_active: "Actif",
  cockpit_channel_hidden: "Masqué",
  cockpit_channel_enable: "Activer",
  cockpit_channel_email: "E-mail",
  cockpit_channel_check: "Vérifier la connexion",
  cockpit_channel_fix: "Vérifier",
  cockpit_channel_forward: "Adresse de transfert",
  cockpit_channel_not_set_up: "Non configuré",
  cockpit_channel_set_up: "Configurer",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "Connexion perdue",
  cockpit_channel_importing: "Importation",
  cockpit_channel_removing: "Déconnexion",
  cockpit_channel_reconnect: "Reconnecter",
  cockpit_channels_title: "Canaux",
  cockpit_company_role_super_admin: "Admin de l'entreprise",
  cockpit_company_role_dept_admin: "Admin de service",
  cockpit_company_role_member: "Collaborateur",
  cockpit_company_none: "Aucune entreprise Kjuup+ trouvée",
  cockpit_company_eyebrow: "Entreprise",
  cockpit_company_inactive: "inactive",
  cockpit_company_settings: "Paramètres de l'entreprise",
  cockpit_company_employees: "Collaborateurs",
  cockpit_company_internal_rooms: "Projets internes",
  cockpit_report_all_projects: "Tous les projets",
  cockpit_report_progress_emails: "Analyse des e-mails",
  cockpit_report_progress_chats: "Analyse des messages de chat",
  cockpit_report_progress_documents: "Analyse des pièces jointes et documents",
  cockpit_report_progress_tasks: "Analyse des tâches",
  cockpit_report_progress_summarizing: "Analyse du contenu",
  cockpit_report_progress_reading: "Réutilisation du contenu déjà analysé",
  cockpit_report_progress_collecting: "Collecte des e-mails, chats et tâches de vos projets",
  cockpit_report_progress_priorities: "Compilation des priorités, échéances et décisions",
  cockpit_report_progress_queued: "Préparation du rapport",
  cockpit_report_creating_title: "Votre rapport quotidien est en préparation",
  cockpit_report_progress_count_one: "1 élément analysé",
  cockpit_report_progress_count_many: "{{count}} éléments analysés",
  cockpit_report_progress_hint: "Cela prend généralement une à deux minutes – vous pouvez continuer à utiliser le cockpit entre-temps.",
  cockpit_report_time_hint: "Le rapport quotidien est créé chaque jour à {{hour}}:00 pour les cinq projets les plus actifs.",
  room_overview_priorities_title: "État actuel et priorités",
  room_overview_as_of: "État au {{time}}",
  cockpit_report_delete: "Supprimer le rapport quotidien",
  email_tag_daily_briefing: "Rapport quotidien",
  cockpit_report_unread: "Nouveau",
  cockpit_report_clear_project: "Afficher tous les projets",
  cockpit_filter_project: "Projet",
  cockpit_filter_all_projects: "Tous les projets",
  cockpit_report_recreate: "Recréer le rapport quotidien",
  cockpit_report_hide_previous: "Masquer les rapports quotidiens précédents",
  cockpit_report_show_previous: "Afficher les rapports quotidiens précédents",
  cockpit_report_room_empty: "Pas encore de rapport quotidien pour ce projet",
  cockpit_report_empty: "Pas encore de rapport quotidien",
  cockpit_report_room_empty_hint: "Créer un rapport quotidien pour ce projet uniquement.",
  cockpit_report_needs_mailbox: "Connectez un compte e-mail pour que Kjuup puisse créer un rapport quotidien avec des tâches automatiques.",
  cockpit_report_create: "Créer un rapport quotidien",
  cockpit_email_connect: "Connecter l'e-mail",
  cockpit_email_none_title: "Aucun compte e-mail connecté pour l'instant",
  cockpit_email_none_reports: "Connectez votre boîte mail pour que Kjuup puisse attribuer les e-mails reçus à vos projets et créer des rapports quotidiens avec des tâches.",
  cockpit_email_none_client: "Connectez Gmail, Outlook ou IMAP pour lire, attribuer et répondre aux e-mails directement dans Kjuup.io.",
  cockpit_email_reports_title: "Client e-mail actuel",
  cockpit_email_reports_text: "Pas de boîte de réception dans Kjuup.io · {{rooms}} projets avec rapport quotidien à {{hour}}:00 · les e-mails reçus sont attribués à vos projets.",
  cockpit_email_reports_rooms: "Gérer les projets",
  cockpit_email_settings: "Paramètres e-mail",
  cockpit_email_error_title: "Vérifier la connexion",
  cockpit_email_client_title: "Boîte de réception connectée",
  cockpit_email_accounts_n: "{{n}} compte connecté",
  cockpit_email_last_sync: "dernière synchro {{when}}",
  cockpit_email_report_at: "Rapport quotidien à {{hour}}:00",
  cockpit_email_open_inbox: "Ouvrir la boîte de réception",
  cockpit_email_eyebrow: "Kjuup-E-mail",
  cockpit_email_accounts_label: "Adresses e-mail connectées",
  email_no_subject: "(Sans objet)",
  cockpit_email_detail_loading: "Chargement de l'e-mail …",
  cockpit_email_detail_failed: "L'e-mail n'a pas pu être chargé.",
  cockpit_email_detail_empty: "Cet e-mail ne contient pas de texte.",
  cockpit_personal_settings: "Paramètres personnels",
  cockpit_companies: "Entreprises",
  cockpit_title: "Cockpit",
  cockpit_back: "Retour à l'aperçu",
  cockpit_day_overview: "Votre journée en un coup d'œil",
  email_saved_to_project: "E-mail enregistré dans le projet",
  email_classify_need_project: "Veuillez saisir un nom de projet",
  cockpit_email_deleted: "E-mail supprimé",
  cockpit_email_sent_empty: "Aucun e-mail envoyé pour l'instant.",
  cockpit_email_incoming_empty: "Aucun e-mail reçu pour l'instant.",
  cockpit_email_incoming_title: "E-mails",
  cockpit_email_incoming_sub: "Attribuez les e-mails reçus et envoyés à vos projets. Vous pouvez ajuster l'attribution ici.",
  cockpit_email_incoming_unassigned_n: "{{n}} non attribué(s)",
  cockpit_email_folder_inbox: "Boîte de réception",
  cockpit_email_folder_sent: "Envoyés",
  cockpit_email_open: "Ouvrir l'e-mail",
  cockpit_email_incoming_suggested: "Suggestion : {{room}}",
  cockpit_email_incoming_apply: "Appliquer",
  cockpit_email_incoming_adjust: "Modifier l'attribution",
  cockpit_email_incoming_saving: "Enregistrement …",
  cockpit_email_incoming_unassigned: "Non attribué",
  cockpit_email_incoming_show_less: "Afficher moins",
  cockpit_email_incoming_show_all: "Tout afficher ({{n}})",
  cockpit_io_settings: "Paramètres Kjuup.io",
  cockpit_io_settings_sub: "Formule et postes, attribution des collaborateurs, facturation et factures.",
  products_coming_soon: "Bientôt disponible",
  cockpit_upsell_io_title: "Votre bureau qui anticipe",
  cockpit_upsell_io_text: "Connectez vos comptes e-mail à Kjuup. E-mails, pièces jointes et messages sont enregistrés automatiquement dans le projet correspondant et peuvent éventuellement être stockés sur votre serveur. Chaque jour, vous recevez un résumé de tous les projets avec les points clés de tous les contenus, et vos tâches se synchronisent avec votre calendrier ou votre application de tâches.",
  cockpit_upsell_io_soon_title: "Pas encore réservable",
  cockpit_upsell_io_soon_text: "Kjuup.io sera bientôt lancé. Demandez des informations dès maintenant – nous vous préviendrons dès que vous pourrez réserver Kjuup.io.",
  cockpit_upsell_io_planned_price: "Prix prévu",
  cockpit_upsell_io_cta_request: "Demander des informations",
  kjuup_plus_abo_per_year: "/ an",
  kjuup_plus_abo_per_month: "/ mois",
  kjuup_plus_abo_status_active: "Actif",
  kjuup_plus_abo_status_requested: "Résiliation demandée",
  kjuup_plus_abo_status_past_due: "Paiement dû",
  kjuup_plus_abo_eyebrow: "Kjuup+ · Abonnement",
  kjuup_plus_abo_title: "Formule Kjuup+",
  kjuup_plus_abo_seats_free_one: "1 poste disponible",
  kjuup_plus_abo_billing: "Facturation",
  kjuup_plus_abo_yearly: "Annuelle",
  kjuup_plus_abo_monthly: "Mensuelle",
  kjuup_plus_abo_amount: "Montant",
  kjuup_plus_abo_ends: "Se termine le",
  kjuup_plus_abo_renews: "Prochain renouvellement",
  kjuup_plus_abo_next_invoice: "Prochaine facture",
  kjuup_plus_abo_intro: "Prix de lancement",
  kjuup_plus_abo_pending_tier: "À partir du prochain renouvellement",
  kjuup_plus_abo_manual: "Kjuup+ est actif pour votre entreprise dans le cadre d'un accord individuel.",
  kjuup_plus_abo_invoices: "Factures",
  kjuup_plus_abo_invoice_paid: "Payée",
  kjuup_plus_abo_invoice_view: "Afficher",
  kjuup_plus_abo_invoices_less: "Afficher moins",
  kjuup_plus_abo_member_hint: "La facturation et la résiliation sont gérées par les administrateurs de votre entreprise.",
  kjuup_plus_abo_withdraw: "Retirer la demande",
  kjuup_plus_abo_cancel_note: "Motif (facultatif)",
  kjuup_plus_abo_cancel_send: "Demander la résiliation",
  kjuup_plus_abo_cancel: "Résilier l'abonnement",
  cockpit_upsell_plus_f1: "Gérez l'activité de communication de tous vos collaborateurs",
  cockpit_upsell_plus_f2: "Informez des groupes d'utilisateurs précis au sein de l'entreprise",
  cockpit_upsell_plus_f3: "Enregistrez les chats de groupe internes",
  cockpit_upsell_plus_when_yearly: "en cas de paiement annuel",
  cockpit_upsell_plus_size_small: "1–50 collaborateurs",
  cockpit_upsell_plus_size_large: "51–200 collaborateurs",
  cockpit_upsell_plus_title: "Kjuup+ pour les entreprises",
  cockpit_upsell_plus_text: "Gérez les collaborateurs, les droits d'écriture et la communication de l'entreprise au même endroit. Les canaux internes restent au sein de votre équipe, les canaux externes vous relient aux partenaires de projet, et vous pouvez joindre directement des groupes précis. En plus de Kjuup+, vous pouvez réserver l'accès Kjuup.io pour des groupes de collaborateurs. Kjuup+ et Kjuup.io peuvent être combinés.",
  cockpit_upsell_plus_size: "Taille de l'entreprise",
  cockpit_upsell_plus_billing: "Facturation",
  cockpit_upsell_plus_per_company: "/ entreprise · mois HT",
  cockpit_upsell_plus_onboarding: "Les frais d'intégration/de mise en route dépendent de la taille de l'entreprise",
  cockpit_upsell_plus_larger: "Tarifs pour les grandes entreprises sur demande",
  cockpit_upsell_plus_cta: "Demande sans engagement",
  cockpit_kpi_deadlines_tasks: "Échéances et tâches",
  cockpit_kpi_appointments: "Rendez-vous",
  cockpit_room_admin: "Gestion des projets et chats",
  cockpit_room_admin_sub: "Tous les projets de l'entreprise avec membres, médias et chats.",
  pro_todo_not_found: "Cette tâche n'est plus disponible.",
  cockpit_chip_overdue: "En retard",
  cockpit_chip_today: "Aujourd'hui",
  cockpit_calendar_week: "Sem. {{week}}",
  cockpit_prev_week: "Semaine précédente",
  cockpit_next_week: "Semaine suivante",
  cockpit_chip_requested: "Demandée",
  cockpit_todo_due: "Échéance {{when}}",
  cockpit_todo_at: "{{time}}",
  cockpit_todo_requested_from: "de {{name}}",
  cockpit_todo_since: "depuis {{when}}",
  cockpit_todo_no_date: "Sans date",
  cockpit_todo_mark_done: "Marquer comme terminée",
  cockpit_my_tasks_title: "Mes tâches",
  cockpit_today_tasks_group: "Tâches du jour",
  cockpit_assign_none: "Personne d'assigné",
  no_project_found: "Aucun projet trouvé",
  cockpit_row_more_actions: "Plus d'actions",
  needs_date: "Définir une date",
  cockpit_assign_proposal: "{{name}} reconnu – assigner ?",
  cockpit_assign_proposal_confirm: "Assigner",
  cockpit_assign_proposal_dismiss: "Ignorer",
  cockpit_priority_date: "Date",
  todo_calendar_add: "Ajouter au calendrier",
  todo_calendar_remove: "Retirer du calendrier",
  cockpit_todo_change_project: "Changer de projet",
  cockpit_todo_set_date: "Définir la date",
  pro_todo_done_confirm: "Voulez-vous vraiment marquer cette tâche comme terminée ?",
  cockpit_task_delete_failed: "La tâche n'a pas pu être supprimée.",
  cockpit_setup_title: "Terminer la configuration",
  cockpit_setup_text: "Choisissez si vous souhaitez utiliser les chats et si Kjuup.io doit fonctionner comme client e-mail ou uniquement avec les projets et les rapports quotidiens.",
  cockpit_setup_cta: "Configurer maintenant",
  cockpit_group_tasks: "Échéances et tâches",
  cockpit_group_appointments: "Rendez-vous",
  cockpit_report_no_activity: "Ce projet n'a reçu ni nouveaux messages ni e-mails au cours des dernières 24 heures.",
  cockpit_report_room_unavailable: "Ce projet n'est pas disponible.",
  cockpit_report_create_failed: "Le rapport quotidien n'a pas pu être créé.",
  cockpit_report_created: "Rapport quotidien créé",
  addon_enable_confirm: "Activer le module complémentaire ?",
  addon_enable: "Activer",
  addon_enabled: "Module complémentaire activé",
  nav_email: "E-mail",
  nav_my_cockpit: "Mon cockpit",
  nav_news: "Actualités",
  nav_recommend: "Recommander",
  pro_todo_status_done: "Terminée",
  pro_todo_status_open: "Ouverte",
  v2_todo_remove: "Retirer",
  pro_todo_search_people: "Rechercher des personnes",
  pro_todo_clear: "Effacer",
  pro_todo_assigned: "(assigné)",
  pro_todo_no_people: "Aucune personne trouvée",
  pro_todo_search_rooms: "Rechercher des projets",
  pro_todo_no_rooms_match: "Aucun projet ne correspond à « {{q}} »",
  pro_todo_no_rooms: "Aucun projet trouvé",
  pro_todo_activity: "Activité",
  pro_todo_show_less: "Afficher moins",
  pro_todo_show_all: "Tout afficher ({{n}})",
  pro_todo_due: "Échéance",
  pro_todo_room: "Projet",
  pro_todo_select_room: "Sélectionner un projet",
  pro_todo_status: "Statut",
  pro_todo_more: "Plus",
  pro_todo_edit_title: "Modifier la tâche",
  pro_todo_description: "Description",
  pro_todo_created_by: "Créée par",
  pro_todo_chat: "Chat",
  navigate_to_source: "Aller à la source",
  todo_calendar_connect_title: "Aucun calendrier connecté",
  todo_calendar_connect_body_web: "Connectez un calendrier dans les paramètres de synchronisation du calendrier pour y ajouter des tâches.",
  todo_calendar_connect: "Connecter",
  todo_calendar_removed: "Retiré de votre calendrier",
  todo_calendar_added_later: "Ajouté. Votre calendrier est inaccessible ; Kjuup réessaiera plus tard.",
  todo_calendar_added: "Ajouté à votre calendrier",
  todo_calendar_no_date: "Seule une tâche avec une date peut être ajoutée à un calendrier.",
  todo_calendar_failed: "Votre calendrier n'a pas pu être mis à jour. Veuillez réessayer.",
  todo_calendar_date_title: "Pas encore de date",
  todo_calendar_date_save: "Définir la date et ajouter",
  todo_calendar_date_body_web: "Cette tâche mise de côté n'a pas encore de date. Définissez-en une pour l'ajouter à votre calendrier.",
  kjuup_io_setup_saved: "Configuration enregistrée",
  kjuup_io_setup_step: "Étape",
  kjuup_io_setup_chats_title: "Souhaitez-vous utiliser les chats ?",
  kjuup_io_setup_email_title: "Où souhaitez-vous lire vos e-mails ?",
  kjuup_io_setup_chats_sub: "Les chats avec les collègues et les partenaires de projet sont facultatifs. Vous pouvez les afficher ou les masquer à tout moment dans le cockpit.",
  kjuup_io_setup_email_sub: "Vous choisissez ici uniquement si vous utilisez un client e-mail dans Kjuup ou si vous gardez votre programme de messagerie actuel, comme Outlook ou un autre. Vous pourrez changer plus tard.",
  kjuup_io_setup_chats_yes: "Oui, afficher les chats",
  kjuup_io_setup_chats_yes_text: "Messages contient les chats et les e-mails. Les projets disposent de chats de groupe pour toutes les personnes concernées.",
  kjuup_io_setup_chats_no: "Non, travailler sans chats",
  kjuup_io_setup_chats_no_text: "Les chats sont masqués. « Messages » devient « E-mail » ; les projets, tâches et rapports quotidiens restent.",
  kjuup_io_setup_email_client: "Client e-mail dans Kjuup",
  kjuup_io_setup_email_client_text: "Lisez et répondez aux e-mails directement dans Kjuup.",
  kjuup_io_setup_email_reports: "Client e-mail actuel",
  kjuup_io_setup_email_reports_text: "Continuez à lire et à répondre dans votre programme actuel, comme Outlook ou un autre.",
  kjuup_io_setup_skip: "Plus tard",
  next: "Suivant",
  kjuup_io_setup_finish: "Terminer la configuration",
  today_label: "aujourd'hui",
  tomorrow_label: "demain",
  cockpit_todo_overdue: "en retard",
  cockpit_report_management_fazit: "Synthèse de direction",
  cockpit_todo_appointment: "Rendez-vous",
  cockpit_todo_deadline: "Échéance",
  cockpit_todo_deadline_define: "Définir l'échéance",
  pro_todo_status_acknowledged: "Confirmée",
  pro_todo_responsible: "Responsable",
  pro_todo_notice_confirmed: "Confirmé dans le chat",
  pro_todo_notice_sent_at: "Message envoyé",
  pro_todo_notice_again: "Renvoyer le message",
  pro_todo_notice_send: "Informer via un message Kjuup",
  pro_todo_add_assignee: "Ajouter",
  pro_todo_edit: "Modifier",
  pro_todo_change_room: "Changer de projet",
  pro_todo_due_on: "Échéance le",
  pro_todo_edit_due: "Modifier l'échéance",
  pro_todo_no_date: "Sans date",
  pro_todo_edit_description: "Modifier la description",
  pro_todo_no_description: "Pas encore de description",
  pro_todo_title_label: "Titre",
  pro_todo_title_placeholder: "Saisissez un titre...",
  pro_todo_task: "Tâche",
  pro_todo_what: "Que faut-il faire ?",
  pro_todo_source_email: "E-mail",
  pro_todo_sources: "Sources",
  previous: "Précédent",
  kjuup_plus_abo_tier_large: "Kjuup+ Large (jusqu'à {max} collaborateurs)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small (jusqu'à {max} collaborateurs)",
  kjuup_plus_abo_status_ends: "Se termine le {date}",
  kjuup_plus_abo_seats_over: "Plus de {max} collaborateurs – Kjuup vous contactera avec une offre personnalisée.",
  kjuup_plus_abo_seats_next: "Si d'autres collaborateurs vous rejoignent, la formule passe automatiquement à {next} (au prorata).",
  kjuup_plus_abo_seats_used: "{used} postes sur {total} occupés",
  kjuup_plus_abo_seats_free: "Encore {count} postes disponibles",
  kjuup_plus_abo_intro_until: "jusqu'au {date}",
  kjuup_plus_abo_invoice_open: "Ouverte · échéance le {date}",
  kjuup_plus_abo_invoices_all: "Tout afficher ({count})",
  kjuup_plus_abo_requested_hint: "Résiliation demandée le {date}. Kjuup la confirme à la fin de la période ({end}).",
  kjuup_plus_abo_cancel_hint: "Kjuup examine votre demande et confirme la résiliation à la fin de la période ({end}). Kjuup+ reste actif jusque-là.",
  kjuup_plus_abo_withdrawn: "Demande de résiliation retirée",
  kjuup_plus_abo_requested: "Résiliation demandée",
  cockpit_upsell_plus_intro_hint: "les {months} premiers mois, puis {price}",
  cockpit_upsell_plus_badge: "PRIX DE LANCEMENT PENDANT {months} MOIS",
  calendar_syncing: "Mise à jour depuis le calendrier…",
  calendar_sync_up_to_date: "Le calendrier est à jour",
  calendar_sync_failed: "Échec de la synchronisation",
  todo_created_from_message: "Tâche créée à partir de ce message",
  kjuup_io_todo_calendar_trial_ended_note: "Synchronisation du calendrier · S'abonner",
  kjuup_io_todo_calendar_nudge: "Synchroniser ce ToDo avec votre calendrier ?",
  kjuup_io_todo_calendar_nudge_cta: "Activer Kjuup.io",
  todo_confirmed: "ToDo confirmé",
  pro_todo_bulk_delete_title: "Supprimer {{n}} tâches ?",
  unassign_task_confirm: "Voulez-vous vous désassigner de cette tâche?",
  pro_todo_delete_title: "Supprimer la tâche",
  pro_todo_today: "Aujourd'hui",
  pro_todo_yesterday: "Hier",
  pro_todo_since_yesterday: "Depuis hier",
  pro_todo_mark_open: "Marquer comme ouverte",
  new_label: "Nouveau",
  bookmarked_no_mylist: "Les tâches mises en signet ne peuvent pas être ajoutées à Ma liste",
  pro_todo_of_completed: "{{done}} sur {{total}} terminées",
  pro_todo_pick_date: "Choisir une date",
  pro_todo_show_day: "Afficher le jour",
  pro_todo_section_upcoming: "À venir",
  pro_todo_section_done: "Terminé",
  pro_todo_room_empty_today: "Aucune tâche aujourd'hui dans ce projet",
  pro_todo_room_empty_day: "Aucune tâche ce jour-là dans ce projet",
  pro_todo_empty_title: "Rien ici",
  pro_todo_empty_hint: "Aucune tâche ne correspond à cette vue.",
  pro_todo_selected: "{{n}} sélectionnées",
  pro_todo_adjust_done: "Terminé",
  pro_todo_deleting: "Suppression...",
  pro_todo_reopen: "Rouvrir la tâche",
  pro_todo_step_done: "Terminé",
  pro_todo_mark_not_started: "Marquer comme non commencé",
  pro_todo_mark_in_progress: "Marquer comme en cours",
  pro_todo_open_room: "Ouvrir le projet",
  pro_todo_new_task: "Nouvelle tâche",
  select_user_back_to_in_progress: "Sélectionnez l'utilisateur à remettre en cours",
  cockpit_email_accounts_n_many: "{{n}} comptes connectés",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Contacts Kjuup",
  combined_tab_teams: "Contacts Teams",
  combined_bridge_failed: "La copie Teams n'a pas pu être créée.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Contacts Kjuup et Teams : un nouveau groupe est créé, qui apparaît aussi dans Microsoft Teams.",
  teams_new_chat_title: "Nouveau chat Teams",
  teams_new_chat_topic: "Nom du groupe (facultatif)",
  teams_new_chat_start: "Démarrer le chat",
  teams_new_chat_creating: "Création du chat…",
  teams_new_chat_forbidden: "Microsoft Teams n'autorise pas ce chat (p. ex. une personne extérieure à votre organisation ou une règle de votre service informatique).",
  teams_new_chat_too_many: "Trop de personnes pour un seul chat.",
  teams_new_chat_type_hint: "Saisissez un nom pour rechercher dans votre organisation.",
  teams_new_chat_directory_forbidden: "Votre organisation n'autorise pas la recherche dans l'annuaire. Seules les personnes de vos chats Teams sont affichées.",
  teams_new_chat_account: "Compte",
};
